module.exports = __webpack_public_path__ + "img/27_48.5c576765.png";